<template>
  <v-container fluid class="pa-1 pos-root">
    <v-row no-gutters class="pos-row">
      <!-- Columna Carrito -->
      <v-col :cols="$vuetify.breakpoint.mdAndUp ? 4 : 12" class="pos-col cart-col pa-2">
        <!-- Header acciones -->
        <v-toolbar dense flat color="grey lighten-4">
          <v-btn large color="success" dark class="mr-2" @click="openManualProduct">
            <v-icon left small>mdi-plus-box</v-icon> Manual
          </v-btn>
          <v-spacer></v-spacer>

          <!-- Scanner -->
          <v-spacer></v-spacer>
          <v-chip outlined>
            <v-icon left small>mdi-package-variant</v-icon>{{ totals.qty }} ítems
          </v-chip>
        </v-toolbar>

        <!-- Tabla Carrito -->
        <div class="cart-table-wrapper">
          <!-- Info rápida cliente -->
          <v-card outlined dense class="mt-2 mb-4 shrink-footer">
            <v-card-text class="py-2">
              <div class="d-flex align-center justify-space-between">
                <span class="font-weight-medium">
                  {{ client.PartyName }}
                </span>
                <v-menu offset-y>
                  <template v-slot:activator="{ on }">
                    <v-btn x-small text v-on="on">
                      <v-icon small>mdi-account-switch</v-icon>
                    </v-btn>
                  </template>
                  <v-list dense>
                    <v-list-item @click="setConsumidorFinal"
                      ><v-list-item-title
                        >Consumidor Final</v-list-item-title
                      ></v-list-item
                    >
                    <v-list-item @click="setClienteContado"
                      ><v-list-item-title>Cliente Contado</v-list-item-title></v-list-item
                    >
                    <v-list-item @click="openClientDialog"
                      ><v-list-item-title
                        >Editar / Identificar</v-list-item-title
                      ></v-list-item
                    >
                  </v-list>
                </v-menu>
              </div>
              <div class="text--secondary text-caption">
                {{ client.PartyIdentification || "GENÉRICO" }} •
                {{ client.AddressLine || "SIN DIRECCIÓN" }}
              </div>
            </v-card-text>
          </v-card>
          <div class="cart-items-scroll">
            <v-data-table
              :headers="cartHeaders"
              :items="cart"
              dense
              :items-per-page="-1"
              hide-default-footer
              rows-per-page-items="-1"
              item-key="ean"
              class="elevation-1 cart-table"
              @click:row="editItem"
            >
              <template v-slot:[`item.descripcion`]="{ item }">
                <div class="font-weight-medium">{{ item.nombre }}</div>
                <div class="text-caption grey--text">
                  {{ item.refe }} {{ item.color }} {{ item.talla }}
                </div>
                <div v-if="item.note" class="text-caption orange--text">
                  <v-icon x-small class="mr-1">mdi-note</v-icon>{{ item.note }}
                </div>
              </template>
              <template v-slot:[`item.cantidad`]="{ item }">
                <div class="d-flex align-center">
                  <v-btn
                    icon
                    x-small
                    @click="changeQty(item, -1)"
                    :disabled="item.cantidad <= 1"
                  >
                    <v-icon x-small>mdi-minus</v-icon>
                  </v-btn>
                  <span class="mx-1">{{ item.cantidad }}</span>
                  <v-btn icon x-small @click="changeQty(item, 1)">
                    <v-icon x-small>mdi-plus</v-icon>
                  </v-btn>
                </div>
              </template>
              <template v-slot:[`item.precio`]="{ item }">
                {{ formatCurrency(item.precio) }}
              </template>
              <template v-slot:[`item.total`]="{ item }">
                {{ formatCurrency(item.precio * item.cantidad) }}
              </template>
              <template v-slot:[`item.actions`]="{ item }">
                <v-btn icon x-small color="error" @click.stop="removeItem(item)">
                  <v-icon x-small>mdi-delete</v-icon>
                </v-btn>
              </template>
              <template v-slot:no-data>
                <div class="text-center py-6 grey--text">
                  <v-icon large color="grey lighten-1">mdi-cart-outline</v-icon>
                  <div class="mt-2">Escanee o use el panel de la derecha</div>
                </div>
              </template>
            </v-data-table>
          </div>
        </div>
        <v-card flat class="mt-0 totals-card">
          <!-- Totales / Pago -->
          <v-card-text class="py-1">
            <v-row dense>
              <v-col cols="6" sm="3">
                <div class="text-caption grey--text">Subtotal</div>
                <div class="font-weight-medium">{{ formatCurrency(subtotal) }}</div>
              </v-col>
              <v-col cols="6" sm="3">
                <div class="text-caption grey--text">Impuestos</div>
                <div class="font-weight-medium">{{ formatCurrency(totalTax) }}</div>
              </v-col>
              <v-col cols="6" sm="3">
                <div class="text-caption grey--text">Pagado</div>
                <div class="font-weight-medium success--text">
                  {{ formatCurrency(totals.paid) }}
                </div>
              </v-col>
              <v-col cols="6" sm="3">
                <div class="text-caption grey--text">Pendiente</div>
                <div
                  class="font-weight-bold"
                  :class="totals.unpaid === 0 ? 'success--text' : 'orange--text'"
                >
                  {{ formatCurrency(totals.unpaid) }}
                </div>
              </v-col>
            </v-row>

            <div v-if="taxBreakdown.length" class="tax-breakdown mt-1">
              <div
                v-for="t in taxBreakdown"
                :key="t.rate"
                class="d-flex justify-space-between text-caption"
              >
                <span>IVA {{ t.rate }}% (Base {{ formatCurrency(t.base) }})</span>
                <span>{{ formatCurrency(t.tax) }}</span>
              </div>
            </div>
            <v-row dense>
              <v-col cols="12" sm="4" class="mb-2 mb-sm-0">
                <v-btn block color="primary" @click="openTablesForViewing">
                  <v-icon left small>mdi-cash-register</v-icon>
                  Cuentas
                </v-btn>
              </v-col>

              <!-- NUEVO: botón guardar sin pago -->
              <v-col cols="12" sm="4" v-if="$vuetify.breakpoint.smAndUp">
                <v-btn
                  color="info"
                  dark
                  :disabled="!canProcessNoPay"
                  @click="checkoutDialog = true"
                >
                  <v-icon left small>mdi-content-save</v-icon>
                  Con Pago
                </v-btn>
              </v-col>
              <v-col cols="12" sm="4">
                <v-btn
                  color="success"
                  dark
                  :disabled="!canProcessNoPay"
                  @click="requestTableForCM"
                >
                  <v-icon left small>mdi-content-save</v-icon>
                  Sin Pago
                </v-btn>
              </v-col>
              <!-- En móviles mostrar debajo -->
              <v-col cols="12" class="mt-2 d-sm-none">
                <v-btn
                  block
                  color="warning"
                  dark
                  :disabled="!canProcessNoPay"
                  @click="requestTableForCM"
                >
                  <v-icon left small>mdi-content-save</v-icon>
                  Guardar Sin Pago
                </v-btn>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>

      <!-- Columna Panel Productos -->
      <v-col :cols="$vuetify.breakpoint.mdAndUp ? 8 : 12" class="pos-col pa-2">
        <div class="product-panel">
          <InvoiceScanner
            ref="scanner"
            @code-scanned="handleBarcodeScanned"
            @show-message="showMessage"
            class="mb-2"
          />

          <!-- Tabs Herramientas -->

          <v-tabs-items v-model="leftTab" class="pad-items">
            <v-tab-item class="pad-item-wrapper">
              <ProductPad
                :cartItemTotal="totals.unpaid"
                @product-selected="add2cart"
                @fastPayment="fastPayment"
              />
            </v-tab-item>
            <v-tab-item class="pad-item-wrapper">
              <PLU
                :cartItemTotal="totals.unpaid"
                @product-selected="add2cart"
                @fastPayment="fastPayment"
              />
            </v-tab-item>
            <v-tab-item class="pad-item-wrapper pa-2">
              <v-btn color="teal" dark block @click="openManualProduct">
                <v-icon left>mdi-plus-box</v-icon> Producto Manual
              </v-btn>
              <div class="text-caption mt-2 grey--text">
                Añade un producto rápido con precio libre.
              </div>
            </v-tab-item>
          </v-tabs-items>
        </div>
      </v-col>
    </v-row>

    <!-- Manual Product -->
    <ManualProduct
      v-model="manualDialog"
      :product-data="manualProduct"
      :is-editing="editing"
      :editing-product-ean="editingEan"
      @product-created="handleManualCreated"
      @product-updated="handleManualUpdated"
      @product-deleted="handleManualDeleted"
    />

    <!-- Checkout -->
    <CheckoutComponent
      v-if="checkoutDialog"
      :visible.sync="checkoutDialog"
      :totalAmount="totals.total"
      :unpaidAmount="totals.unpaid"
      :vendors="vendors"
      :paymentMethods="FP"
      :idList="dynamicSettings.documentTypes"
      :municipalities="[]"
      :companyData="company"
      :clientData="client"
      :validations="checkoutValidations"
      @process-payment="processPayment"
      @show-message="showMessage"
      @open-client-dialog="openClientDialog"
    />

    <!-- Visualizador de documentos -->

    <docViewer
      :item="item"
      :dialog="dialog"
      :newInvoice="nInvoice"
      @close="dialog = false"
      @refresh="refresh_view()"
    />

    <TableManager
      :storeId="company.store_id"
      :dialog.sync="table_dialog"
      @close-dialog="onTableDialogClose"
      @table-selected="TableSelected"
    />

    <!-- (Opcional) Dialog Cliente futuro -->
  </v-container>
</template>

<script>
import { formatCurrency, webserver } from "@/services/webserver.js";
import ProductPad from "@/views/pos/ProductPad.vue";
import PLU from "@/views/pos/PLUD.vue";
import InvoiceScanner from "./components/InvoiceScanner.vue";
import ManualProduct from "./components/ManualProduct.vue";
import CheckoutComponent from "@/components/checkout.vue";
import createPayment from "@/utils/createPayment.js";
import createDoc from "@/utils/create_doc.js";
import createCompany from "@/utils/createCompany.js";
import docViewer from "@/components/doc_viewer.vue";
import TableManager from "@/components/TableManager.vue";
import countryUtils from "@/utils/countryUtils.js";

export default {
  name: "InvoicePOS",
  components: {
    ProductPad,
    PLU,
    InvoiceScanner,
    ManualProduct,
    CheckoutComponent,
    docViewer,
    TableManager,
  },
  data() {
    return {
      table_dialog: false,
      pendingNoPaySave: false, // flag: true cuando "Sin Pago" abrió el dialog para crear CM
      leftTab: 0,
      cart: [],
      payments: [],
      totals: { qty: 0, total: 0, paid: 0, unpaid: 0 },
      client: {
        PartyName: "CONSUMIDOR FINAL",
        PartyIdentification: "222222222222",
        AddressLine: "",
        client_email: "",
        client_phone: "",
        CityName: "",
        typeid: "CC",
      },
      manualDialog: false,
      manualProduct: {
        nombre: "",
        descripcion: "",
        note: "",
        cantidad: 1,
        precio: "",
        descuento: 0,
        tax: 19,
        manual: true,
      },
      editing: false,
      editingEan: null,
      checkoutDialog: false,
      FP: (window.settings && window.settings.FP) || [],
      vendors: [],
      vendor: null,
      company: createCompany(),
      payment: createPayment(),
      documentType: "FE", // Factura Electrónica por defecto para Colombia
      processing: false,
      dialog: false,
      item: createDoc(),
      nInvoice: true,
      FP_DEFAULT: { codigo: "01", valor: "EFECTIVO" },
      dynamicSettings: {
        documentTypes: [],
        departments: [],
        liabilityTypes: [],
        organizationTypes: [],
        regimeTypes: [],
        vatRates: [],
      },
      clientesGenericos: {
        contado: {
          PartyIdentification: "99999999R",
          PartyName: "CLIENTE CONTADO",
          typeid: "DNI",
          AddressLine: "Venta mostrador",
          client_email: "",
          client_phone: "",
        },
        consumidor: {
          PartyIdentification: "222222222222",
          PartyName: "CONSUMIDOR FINAL",
          typeid: "CC",
          AddressLine: "Consumidor Final",
          client_email: "",
          client_phone: "",
        },
      },
      cartHeaders: [
        { text: "Descripción", value: "descripcion", width: "40%" },
        { text: "Cant", value: "cantidad", align: "center", width: "12%" },
        { text: "Precio", value: "precio", align: "right", width: "16%" },
        { text: "Total", value: "total", align: "right", width: "16%" },
        { text: "", value: "actions", align: "center", width: "8%", sortable: false },
      ],
      checkoutValidations: [
        // NUEVO: estructura completa para evitar undefined
        { key: "client", status: null, label: "Nombre del cliente requerido" },
        { key: "email", status: true, label: "Correo electrónico es opcional" },
        { key: "document", status: null, label: "Documento de identificación requerido" },
        { key: "doctype", status: null, label: "Tipo de documento requerido" },
        { key: "vendor", status: null, label: "Vendedor requerido" },
        { key: "electronic", status: false, label: "Requiere Factura Electrónica" },
        { key: "value", status: false, label: "Valor" },
        { key: "city", status: null, label: "Ciudad requerida" },
      ],
    };
  },
  computed: {
    subtotal() {
      return this.cart.reduce((s, i) => s + i.precio * i.cantidad, 0);
    },
    totalTax() {
      return this.cart.reduce((s, item) => {
        const { taxUnit } = this.computeItemAmounts(item);
        return s + taxUnit * item.cantidad;
      }, 0);
    },
    taxBreakdown() {
      const map = {};
      this.cart.forEach((item) => {
        const rate = parseFloat(item.tax) || 0;
        const { baseUnit, taxUnit } = this.computeItemAmounts(item);
        if (!map[rate]) map[rate] = { rate, base: 0, tax: 0 };
        map[rate].base += baseUnit * item.cantidad;
        map[rate].tax += taxUnit * item.cantidad;
      });
      return Object.values(map)
        .filter((r) => r.tax > 0.0001)
        .sort((a, b) => b.rate - a.rate);
    },
    canProcess() {
      return this.cart.length > 0 && this.totals.unpaid === 0 && !this.processing;
    },
    // NUEVO: permitir guardar aun con saldo pendiente
    canProcessNoPay() {
      return this.cart.length > 0 && !this.processing;
    },
  },
  mounted() {
    this.loadVendors();
    this.loadDynamicSettings();
    this.company = window.seller || this.company;
  },
  watch: {
    // ✅ RESETEAR completamente cuando se cierra el doc_viewer
    dialog(newVal) {
      if (!newVal) {
        this.reset(); // ✅ Ahora puede resetear el item porque dialog está cerrado
      }
    },
  },
  methods: {
    refresh_view() {
      var e = this.item;
      var issudate = e.issuedate.split(" ");
      var doc = {
        store: e.store,
        issueDate: issudate[0],
        did: e.doc_number,
      };
      this.loading_status = true;
      webserver("get_invoice_fe", doc, (data) => {
        this.loading_status = false;
        this.item = data;
        this.dialog = true;
      });
    },
    TableSelected(table) {
      console.log("Mesa seleccionada:", table);
      this.table_dialog = false;
      this.client = {
        PartyName: table.name,
        PartyIdentification: table.id || "",
        AddressLine: "",
        client_email: "",
        client_phone: "",
        CityName: "",
        typeid: table.type || "CC",
      };

      // Si veníamos de "Sin Pago", ahora sí disparar la creación del CM
      if (this.pendingNoPaySave) {
        this.pendingNoPaySave = false;
        this.$nextTick(() => {
          this.processInvoiceNoPayment(table);
        });
      }
    },

    // "Sin Pago": NO postea CM directo. Primero pide mesa/cuenta.
    requestTableForCM() {
      if (!this.canProcessNoPay) {
        this.showMessage({
          text: "Agregue al menos un producto al carrito",
          color: "warning",
        });
        return;
      }
      if (this.processing) return;
      this.pendingNoPaySave = true;
      this.table_dialog = true;
    },

    // "Cuentas": abre el selector solo para ver/cambiar cliente activo.
    openTablesForViewing() {
      this.pendingNoPaySave = false; // explícitamente NO es flujo de guardado
      this.table_dialog = true;
    },

    // Cancelar la apertura del selector limpia el flag para evitar disparos accidentales
    onTableDialogClose() {
      this.table_dialog = false;
      this.pendingNoPaySave = false;
    },

    // Tras CM exitoso: actualizar la mesa en localStorage (acumular total + marcar ocupada)
    afterCMPosted(tableId, addedTotal) {
      if (!tableId || tableId === "222222222222") return; // no actualizar consumidor genérico
      try {
        const storeId = window.store && window.store.store_id;
        if (!storeId) return;
        const key = `tables_${storeId}`;
        const raw = localStorage.getItem(key);
        if (!raw) return;
        const tables = JSON.parse(raw);
        const idx = tables.findIndex((t) => t.id === tableId);
        if (idx === -1) return;
        const fresh = tables[idx];
        tables[idx] = {
          ...fresh,
          status: "occupied",
          hasOrders: true,
          totalAmount:
            (parseFloat(fresh.totalAmount) || 0) + (parseFloat(addedTotal) || 0),
          startTime: fresh.startTime || new Date().toISOString(),
        };
        localStorage.setItem(key, JSON.stringify(tables));
      } catch (e) {
        console.warn("No se pudo actualizar mesa en localStorage:", e);
      }
    },

    // Reset tras CM: limpia cart pero MANTIENE la mesa como cliente activo
    // Permite seguir agregando comandas a la misma mesa sin volver a seleccionarla
    resetAfterCM() {
      this.payment = createPayment();
      this.cart = [];
      this.payments = [];
      this.updateTotals();
      // No tocar this.client — mesa actual queda activa
      // No abrir table_dialog
    },
    formatCurrency,
    loadVendors() {
      webserver("vendors", { store: window.store.store_id }, (data) => {
        this.vendors = data;
        if (data[0]) this.vendor = data[0].codigo;
      });
    },
    loadDynamicSettings() {
      try {
        console.log("🌍 Cargando configuraciones dinámicas para InvoicePOS...");

        // Cargar configuraciones específicas por país
        this.dynamicSettings = {
          documentTypes: countryUtils.getDocumentTypes(),
          departments: countryUtils.getDepartments(),
          liabilityTypes: countryUtils.getLiabilityTypes(),
          organizationTypes: countryUtils.getOrganizationTypes(),
          regimeTypes: countryUtils.getRegimeTypes(),
          vatRates: countryUtils.getVatRates(),
        };

        // 🇨🇴 COLOMBIA: Actualizar clientes genéricos según el país
        const countryCode = countryUtils.getCurrentCountryCode();
        if (countryCode === "CO") {
          this.clientesGenericos = {
            contado: {
              PartyIdentification: "222222222222",
              PartyName: "CLIENTE CONTADO",
              typeid: "CC",
              AddressLine: "Venta mostrador",
              client_email: "",
              client_phone: "",
            },
            consumidor: {
              PartyIdentification: "222222222222",
              PartyName: "CONSUMIDOR FINAL",
              typeid: "CC",
              AddressLine: "Consumidor Final",
              client_email: "",
              client_phone: "",
            },
          };
        }

        console.log("✅ Configuraciones dinámicas cargadas:", {
          country: countryUtils.getCurrentCountryCode(),
          documentsCount: this.dynamicSettings.documentTypes.length,
          departmentsCount: this.dynamicSettings.departments.length,
        });
      } catch (error) {
        console.error("❌ Error cargando configuraciones dinámicas:", error);
        this.showMessage({
          text: "Error cargando configuraciones del país",
          color: "error",
          timeout: 3000,
        });
      }
    },
    handleBarcodeScanned(code) {
      const qry = {
        store: window.store.store_id,
        dbSearch: "inventory",
        filters: [
          { field: "id_pos", operator: "=", value: window.store.store_id },
          { field: "ean", operator: "=", value: code },
        ],
      };
      webserver("get_catalog", qry, (data) => {
        if (data[0]) this.add2cart(data[0]);
        else this.showMessage({ text: "Producto no encontrado", color: "error" });
      });
    },
    showMessage(msg) {
      this.$store && this.$store.commit("setSnackbar", msg);
    },
    add2cart(raw) {
      // Clonar para no mutar el objeto fuente
      const itm = { ...raw };
      const rawSnapshot = JSON.parse(JSON.stringify(itm));
      // Normalizar precio bruto
      itm.precio = parseFloat(itm.precio || itm.price || 0);
      itm.cantidad = 1;
      itm.note = itm.note || "";
      // Asegurar descuento numérico
      itm.discount = parseFloat(itm.discount || itm.descuento || 0) || 0;
      // Normalizar tasa impuesto (cadena -> número). No forzar 19 si ya trae valor (incluye 0 o 8)
      const originalTax = itm.tax !== undefined ? itm.tax : itm.taxes;
      let parsedTax =
        originalTax === undefined || originalTax === null || originalTax === ""
          ? undefined
          : parseFloat(originalTax);
      if (isNaN(parsedTax)) parsedTax = undefined;
      if (parsedTax === undefined) {
        parsedTax = 19; // fallback
        itm._taxSource = "default-19";
      } else {
        itm._taxSource = "source";
      }
      itm.tax = parsedTax; // guardamos como número

      // Si trae ean vacío generamos uno
      if (!itm.ean) itm.ean = `M-${Date.now()}`;

      // Calcular base/impuesto unitarios si no vienen o si están inconsistentes
      const epsilon = 0.02; // tolerancia redondeo
      const alreadyHasUnit = itm.price_amount !== undefined && itm.item_tax !== undefined;

      if (alreadyHasUnit) {
        // Si ya vienen los valores, usarlos directamente
        // NO recalcular basándonos en el precio bruto porque puede causar inconsistencias
        itm.price_amount = +parseFloat(itm.price_amount).toFixed(2);
        itm.item_tax = +parseFloat(itm.item_tax).toFixed(2);

        // Verificar consistencia pero solo para logging
        const recomposed = itm.price_amount + itm.item_tax;
        if (Math.abs(recomposed - itm.precio) > epsilon) {
          console.warn(
            "[POS] Valores inconsistentes detectados pero usando los originales:",
            {
              price_amount: itm.price_amount,
              item_tax: itm.item_tax,
              suma: recomposed,
              precio: itm.precio,
              diferencia: recomposed - itm.precio,
            }
          );
        }
        itm._recalc = false;
      } else {
        // Solo si NO vienen los valores, calcularlos
        const { baseUnit, taxUnit } = this.computeItemAmounts(itm);
        itm.price_amount = +baseUnit.toFixed(2);
        itm.item_tax = +taxUnit.toFixed(2);
        itm._recalc = true;
      }
      // Totales de línea derivados (para inspección)
      itm.line_base_total = +(itm.price_amount * itm.cantidad).toFixed(2);
      itm.line_tax_total = +(itm.item_tax * itm.cantidad).toFixed(2);
      itm.line_gross_total = +(itm.precio * itm.cantidad).toFixed(2);

      console.log("[POS] add2cart -> RAW", rawSnapshot);
      console.log("[POS] add2cart -> NORMALIZED", {
        ean: itm.ean,
        nombre: itm.nombre,
        precio_bruto: itm.precio,
        tax: itm.tax,
        tax_source: itm._taxSource,
        price_amount_unit: itm.price_amount,
        item_tax_unit: itm.item_tax,
        line_base_total: itm.line_base_total,
        line_tax_total: itm.line_tax_total,
        recomputed: itm._recalc,
      });

      const idx = this.cart.findIndex((p) => p.ean === itm.ean);
      if (idx === -1) {
        this.cart.push(itm);
      } else {
        this.cart[idx].cantidad++;
        // actualizar totales de línea para el existente
        this.cart[idx].line_base_total = +(
          this.cart[idx].price_amount * this.cart[idx].cantidad
        ).toFixed(2);
        this.cart[idx].line_tax_total = +(
          this.cart[idx].item_tax * this.cart[idx].cantidad
        ).toFixed(2);
        this.cart[idx].line_gross_total = +(
          this.cart[idx].precio * this.cart[idx].cantidad
        ).toFixed(2);
        console.log("[POS] add2cart -> INCREMENT", {
          ean: this.cart[idx].ean,
          nueva_cantidad: this.cart[idx].cantidad,
          line_base_total: this.cart[idx].line_base_total,
          line_tax_total: this.cart[idx].line_tax_total,
        });
      }
      console.log("[POS] add2cart -> CART", this.cart);
      this.updateTotals();
    },
    computeItemAmounts(item) {
      const taxRate = parseFloat(item.tax) || 0;
      const gross = parseFloat(item.precio) || 0;
      if (taxRate <= 0) return { baseUnit: gross, taxUnit: 0 };
      const baseUnit = +(gross / (1 + taxRate / 100)).toFixed(4); // mayor precisión
      const taxUnit = +(gross - baseUnit).toFixed(4);
      return { baseUnit, taxUnit };
    },
    changeQty(item, delta) {
      if (delta < 0 && item.cantidad <= 1) return;
      item.cantidad += delta;
      this.updateTotals();
    },
    removeItem(item) {
      const idx = this.cart.indexOf(item);
      if (idx > -1) this.cart.splice(idx, 1);
      this.updateTotals();
    },
    updateTotals() {
      this.totals.qty = 0;
      this.totals.total = 0;
      this.totals.paid = 0;
      this.cart.forEach((i) => {
        this.totals.qty += i.cantidad;
        this.totals.total += i.cantidad * i.precio;
      });
      this.payments.forEach((p) => {
        if (p.payment_code !== "00") this.totals.paid += parseFloat(p.payment_value);
      });
      this.totals.unpaid = this.totals.total - this.totals.paid;
      this.payment.payment_value = this.totals.unpaid;

      // ✅ PROCESAMIENTO AUTOMÁTICO: Cuando el pago está completo, procesar factura FE
      if (this.totals.unpaid === 0 && this.totals.total > 0 && !this.processing) {
        console.log("✅ Pago completo, procesando factura FE automáticamente...");
        this.processInvoice();
      }
    },
    fastPayment() {
      if (this.totals.unpaid <= 0) return;
      this.payments.push({
        payment_concept: "EFECTIVO",
        payment_code: "01",
        payment_reference: "PAGO RAPIDO",
        payment_value: this.totals.unpaid,
      });
      this.updateTotals();
    },
    openManualProduct() {
      this.editing = false;
      this.editingEan = null;
      this.manualDialog = true;
    },
    handleManualCreated(prod) {
      this.add2cart(prod);
      this.showMessage({ text: "Producto manual agregado", color: "success" });
    },
    handleManualUpdated({ product, ean }) {
      const idx = this.cart.findIndex((i) => i.ean === ean);
      if (idx > -1) {
        this.$set(this.cart, idx, { ...this.cart[idx], ...product });
        this.updateTotals();
        this.showMessage({ text: "Producto actualizado", color: "success" });
      }
    },
    handleManualDeleted({ ean }) {
      const idx = this.cart.findIndex((i) => i.ean === ean);
      if (idx > -1) {
        this.cart.splice(idx, 1);
        this.updateTotals();
        this.showMessage({ text: "Producto eliminado", color: "info" });
      }
    },
    editItem(item) {
      this.manualProduct = {
        ...item,
        precio: item.precio,
        descuento: item.descuento || 0,
      };
      this.editing = true;
      this.editingEan = item.ean;
      this.manualDialog = true;
    },
    processPayment(paymentData) {
      console.log("=== RECIBIENDO PAGO EN INVOICEPOS ===");
      console.log("paymentData recibido:", paymentData);

      const { payment, pay_mode, vendor, client, doctype } = paymentData;

      // Validar datos recibidos
      if (!payment || !pay_mode || !vendor) {
        console.error("❌ Datos de pago incompletos:", { payment, pay_mode, vendor });
        this.showMessage({
          text: "Error: Datos de pago incompletos",
          color: "error",
          timeout: 3000,
        });
        return;
      }

      // Validar valor del pago
      if (!payment.payment_value || payment.payment_value <= 0) {
        console.error("❌ Valor de pago inválido:", payment.payment_value);
        this.showMessage({
          text: "Error: Valor de pago inválido",
          color: "error",
          timeout: 3000,
        });
        return;
      }

      console.log("✅ Datos validados, procesando pago...");

      // Actualizar datos del componente
      this.vendor = vendor;
      this.documentType = doctype || this.documentType;
      if (client) {
        this.client = { ...client };
      }

      // Ajustar efectivo con cambio
      if (pay_mode.codigo === "01" && payment.payment_value > this.totals.unpaid) {
        const change = payment.payment_value - this.totals.unpaid;
        this.payments.push({
          payment_concept: pay_mode.valor,
          payment_code: pay_mode.codigo,
          payment_reference: "EFECTIVO",
          payment_value: this.totals.unpaid,
        });
        this.payments.push({
          payment_concept: "CAMBIO",
          payment_code: "01",
          payment_reference: `Cambio ${this.formatCurrency(change)}`,
          payment_value: 0,
        });
        console.log("✅ Pago en efectivo con cambio procesado");
      } else if (payment.payment_value <= this.totals.unpaid) {
        this.payments.push({
          payment_concept: pay_mode.valor,
          payment_code: pay_mode.codigo,
          payment_reference: payment.payment_reference || pay_mode.valor,
          payment_value: payment.payment_value,
        });
        console.log("✅ Pago procesado:", payment.payment_value);
      } else {
        console.error("❌ Valor excede el monto pendiente");
        this.showMessage({
          text: "Error: El valor excede el monto pendiente",
          color: "error",
          timeout: 3000,
        });
        return;
      }

      this.updateTotals();

      // Mostrar mensaje de confirmación
      this.showMessage({
        text: `Pago registrado: ${this.formatCurrency(payment.payment_value)}`,
        color: "success",
        timeout: 2000,
      });

      console.log("💰 Totales actualizados:", this.totals);
    },
    openCheckout() {
      if (this.cart.length === 0) return;
      this.resetValidationStatus(); // NUEVO
      this.checkoutDialog = true;
    },
    resetValidationStatus() {
      // NUEVO: resetear todas las validaciones
      this.checkoutValidations.forEach((v) => {
        if (v.key === "email" || v.key === "electronic" || v.key === "value") {
          // Estos campos son opcionales o tienen lógica especial
          v.status = v.key === "email" ? true : false;
        } else {
          // Los demás se ponen en null para indicar que necesitan validación
          v.status = null;
        }
      });
    },
    reset() {
      this.payment = createPayment();
      this.cart = [];
      this.payments = [];
      //this.item = createDoc(); // ✅ Ahora siempre resetear item (se llama solo cuando dialog cerrado)
      this.updateTotals();
      this.TableSelected({ name: "CONSUMIDOR FINAL", id: "222222222222", type: "CC" });
      this.table_dialog = true;
    },
    // ✅ NUEVO: Resetear solo cart y payments después de procesar (sin tocar item)

    processInvoice() {
      if (!this.canProcess) return;
      this.processing = true;

      // Procesar items con campos calculados
      const processedItems = this.cart.map((item) => {
        const { baseUnit, taxUnit } = this.computeItemAmounts(item);
        return {
          ...item,
          qty: item.cantidad,
          price_amount: +baseUnit.toFixed(2),
          item_tax: +taxUnit.toFixed(2),
          discount: item.discount || 0,
        };
      });

      // Agregar typeid al cliente si tiene identificación
      const processedBuyer = {
        ...this.client,
        typeid: this.client.typeid ? "CC" : undefined,
      };

      const invoice = {
        buyer: processedBuyer,
        doc: {
          doc_type: "FE",
          doc_value: this.totals.total,
          store: window.store.store_id,
          userId: window.profile.user_email,
          vendor: this.vendor,
        },
        items: processedItems,
        payments: this.payments,
        seller: window.seller,
        store: window.store.store_id,
      };
      console.log("🌐 Enviando factura al servidor:", invoice);
      webserver("post_invoice", invoice, (data) => {
        console.log("✅ Factura procesada:", data);
        this.processing = false;
        this.item = { ...data };

        this.dialog = true;

        this.showMessage({ text: "Factura procesada", color: "success" });
        this.reset();
      });
    },
    // NUEVO: guardar / procesar sin pagos (pagos vacíos o parciales)
    // table: mesa seleccionada (la pasa TableSelected). Si null, usa el cliente actual.
    processInvoiceNoPayment(table = null) {
      if (!this.canProcessNoPay) return;
      if (this.processing) return;
      this.processing = true;

      // Procesar items con campos calculados
      const processedItems = this.cart.map((item) => {
        const { baseUnit, taxUnit } = this.computeItemAmounts(item);
        return {
          ...item,
          qty: item.cantidad,
          price_amount: +baseUnit.toFixed(2),
          item_tax: +taxUnit.toFixed(2),
          discount: item.discount || 0,
        };
      });

      // Agregar typeid al cliente si tiene identificación
      const processedBuyer = {
        ...this.client,
        typeid: this.client.PartyIdentification ? "CC" : undefined,
      };

      const invoice = {
        buyer: processedBuyer,
        doc: {
          doc_type: "CM",
          doc_number: null,
          doc_value: this.totals.total, // registrar valor completo aunque no haya pagos
          store: window.store.store_id,
          userId: window.profile.user_email,
          vendor: this.vendor,
          //unpaid_value: this.totals.unpaid, // referencia del saldo
        },
        items: processedItems,
        payments: this.payments.length ? this.payments : [], // puede ir vacío
        seller: window.seller,
        store: window.store.store_id,
      };
      const cmTotal = this.totals.total;
      const targetTable = table || {
        id: this.client && this.client.PartyIdentification,
        name: this.client && this.client.PartyName,
      };

      console.log("[CM] Enviando payload:", JSON.parse(JSON.stringify(invoice)));

      webserver("post_invoice_cm", invoice, (data) => {
        this.processing = false;

        // Caso 1: error real del wrapper webserver (timeout, status != 200, etc.)
        if (!data || (data.error === true)) {
          this.showMessage({
            text:
              "Error de red guardando la comanda: " +
              ((data && data.message) || "respuesta vacía"),
            color: "error",
          });
          console.warn("[CM] Error de red:", data);
          return;
        }

        // Caso 2: el backend devolvió un mensaje string en `error` (ej: "No documents found")
        if (typeof data.error === "string") {
          this.showMessage({
            text: "El backend rechazó la comanda: " + data.error,
            color: "error",
          });
          console.warn("[CM] Backend rechazó:", data.error);
          return;
        }

        // La respuesta válida tiene la forma { company, seller, document, buyer, items }
        const savedDoc = data.document || {};
        console.log(
          "[CM] Documento guardado — doc_type:",
          savedDoc.doc_type,
          "doc_number:",
          savedDoc.doc_number,
          "issuedate:",
          savedDoc.issuedate,
          "PartyIdentification:",
          (data.buyer && data.buyer.PartyIdentification) || savedDoc.PartyIdentification
        );

        if (!savedDoc.doc_number && !savedDoc.doc_type) {
          this.showMessage({
            text:
              "El backend respondió sin doc_number/doc_type dentro de document. Revise endpoint.",
            color: "error",
          });
          console.warn("[CM] Respuesta sin estructura document esperada:", data);
          return;
        }

        this.nInvoice = true;
        this.item = { ...data };
        this.dialog = true;

        // Acumular total y marcar ocupada en la mesa elegida (localStorage)
        if (targetTable && targetTable.id) {
          this.afterCMPosted(targetTable.id, cmTotal);
        }

        const mesaName = (targetTable && targetTable.name) || "cliente actual";
        this.showMessage({
          text: `Comanda ${savedDoc.doc_number || ""} guardada en ${mesaName}`,
          color: "success",
        });
        this.resetAfterCM();
      });
    },
    saveHold() {
      // Placeholder: aquí se podría llamar a invoice_save o endpoint nuevo
      this.showMessage({ text: "Cuenta retenida (placeholder)", color: "info" });
    },
    setConsumidorFinal() {
      this.client = {
        ...this.clientesGenericos.consumidor,
        CityName: this.company.city_code || this.client.CityName,
      };
    },
    setClienteContado() {
      this.client = {
        ...this.clientesGenericos.contado,
        CityName: this.company.city_code || this.client.CityName,
      };
    },
    openClientDialog() {
      this.showMessage({
        text: "Implementar diálogo cliente (placeholder)",
        color: "info",
      });
    },
  },
};
</script>

<style scoped>
.v-toolbar {
  flex: none;
}

/* CONTENEDOR TOTAL: alto fijo del viewport, no scrollea ni se sale */
.pos-root {
  height: calc(100vh - 48px) !important;       /* app-bar dense = 48px */
  max-height: calc(100vh - 48px) !important;
  display: flex !important;
  flex-direction: column !important;
  overflow: hidden !important;
  background-color: #f5f5f5;
  box-sizing: border-box;
}

.pos-row {
  flex: 1 1 0 !important;
  min-height: 0 !important;
  display: flex !important;
  flex-direction: row !important;
  flex-wrap: nowrap !important;       /* las cols NO bajan a otra línea */
  overflow: hidden !important;
  gap: 8px;
  margin: 0 !important;
}

.pos-col {
  display: flex !important;
  flex-direction: column !important;
  min-height: 0 !important;
  min-width: 0;
  overflow: hidden !important;
  flex: 1 1 0 !important;             /* respeta cols=4/cols=8 vía max-width pero permite shrink */
}

/* En móvil sí permitimos stack vertical */
@media (max-width: 959px) {
  .pos-row {
    flex-direction: column !important;
    flex-wrap: wrap !important;
  }
  .pos-col {
    flex: 1 1 auto !important;
  }
}

.cart-col {
  display: flex !important;
  flex-direction: column !important;
  min-height: 0 !important;
  overflow: hidden !important;
}

/* Wrapper del carrito (toolbar + cliente + tabla + totales) */
.cart-table-wrapper {
  flex: 1 1 0 !important;
  min-height: 0 !important;
  display: flex !important;
  flex-direction: column !important;
  overflow: hidden !important;
}

/* Único punto de scroll del carrito */
.cart-items-scroll {
  flex: 1 1 0 !important;
  min-height: 0 !important;
  overflow-y: auto !important;
}

.cart-table {
  display: flex;
  flex-direction: column;
}

.totals-card {
  flex: 0 0 auto;
}

.product-panel {
  flex: 1 1 0 !important;
  display: flex !important;
  flex-direction: column !important;
  min-height: 0 !important;
  overflow: hidden !important;
}

.shrink-tabs {
  flex: 0 0 auto;
}

.pad-items {
  flex: 1 1 0 !important;
  display: flex !important;
  flex-direction: column !important;
  min-height: 0 !important;
  overflow: hidden !important;
}

/* Vuetify inserta .v-window__container entre v-window y v-window-item:
   forzamos que herede el flex column y la altura disponible */
.pad-items::v-deep > .v-window__container {
  flex: 1 1 0 !important;
  min-height: 0 !important;
  display: flex !important;
  flex-direction: column !important;
  height: 100% !important;
  overflow: hidden !important;
}

.pad-item-wrapper {
  flex: 1 1 0 !important;
  min-height: 0 !important;
  display: flex !important;
  flex-direction: column !important;
  overflow: hidden !important;
}

.pad-item-wrapper > * {
  flex: 1 1 0 !important;
  min-height: 0 !important;
}

.shrink-footer {
  flex: 0 0 auto;
}
</style>
